<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Button from '../../../Button.svelte';

  export let charityName = '';
  export let leaveHours = '';

  const dispatch = createEventDispatcher();

  function handleViewRequest() {
    dispatch('viewRequest');
  }

  function handleReturnToDashboard() {
    dispatch('returnToDashboard');
  }

  // Format current date
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Convert hours to days (assuming 8 hours per day)
  $: donationDays = Math.ceil(parseInt(leaveHours) / 8);
</script>

<div class="step-container">
  <!-- Header -->
  <div class="step-header">
    <button class="back-button" on:click={handleReturnToDashboard}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H6m6-6l-6 6 6 6"/>
      </svg>
    </button>
    <h2 class="step-title">Donation Request Submitted</h2>
    <div class="header-spacer"></div>
  </div>

  <!-- Success Icon -->
  <div class="success-icon">
    <div class="success-circle">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
        <polyline points="20,6 9,17 4,12"/>
      </svg>
    </div>
  </div>

  <!-- Success Message -->
  <div class="success-content">
    <h3 class="success-title">Donation Request Submitted!</h3>
    <p class="success-message">
      Your leave donation request to {charityName} has been submitted and is pending employer approval.
    </p>
  </div>

  <!-- Donation Details -->
  <div class="donation-summary">
    <div class="summary-item">
      <h4 class="summary-label">Requested Amount</h4>
      <p class="summary-value">{donationDays} Days of Leave</p>
    </div>

    <div class="summary-item">
      <h4 class="summary-label">Date</h4>
      <p class="summary-value">{currentDate}</p>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <Button 
      variant="primary"
      fullWidth={true}
      on:click={handleViewRequest}
    >
      View Request
    </Button>
    
    <Button 
      variant="secondary"
      fullWidth={true}
      on:click={handleReturnToDashboard}
    >
      Return to Donations
    </Button>
  </div>
</div>

<style>
  .step-container {
    padding: 1.5rem;
    max-height: 80vh;
    overflow-y: auto;
    background-color: #f9fafb;
    text-align: center;
  }

  .step-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
  }

  .back-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    color: #6b7280;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-button:hover {
    background-color: #f3f4f6;
    color: #374151;
  }

  .step-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    text-align: center;
    flex: 1;
  }

  .header-spacer {
    width: 40px; /* Same width as back button for centering */
  }

  .success-icon {
    margin: 2rem 0;
    display: flex;
    justify-content: center;
  }

  .success-circle {
    width: 80px;
    height: 80px;
    background-color: #10b981;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: successPulse 0.6s ease-out;
  }

  .success-circle svg {
    color: white;
  }

  @keyframes successPulse {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .success-content {
    margin-bottom: 2rem;
  }

  .success-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 1rem 0;
  }

  .success-message {
    color: #6b7280;
    font-size: 1rem;
    line-height: 1.5;
    margin: 0;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }

  .donation-summary {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 2rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: left;
  }

  .summary-item {
    margin-bottom: 1.5rem;
  }

  .summary-item:last-child {
    margin-bottom: 0;
  }

  .summary-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    margin: 0 0 0.5rem 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .summary-value {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    line-height: 1.4;
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }



  /* Responsive design */
  @media (max-width: 768px) {
    .step-container {
      padding: 1rem;
    }

    .success-circle {
      width: 64px;
      height: 64px;
    }

    .success-circle svg {
      width: 24px;
      height: 24px;
    }

    .success-title {
      font-size: 1.25rem;
    }

    .success-message {
      font-size: 0.875rem;
    }

    .donation-summary {
      padding: 1.25rem;
    }

    .step-title {
      font-size: 1.125rem;
    }
  }
</style> 